import { useNotificationQueryStore } from '../stores/notification.query-store'
import { useNotificationUIStore } from '../stores/notification.ui-store'

export const useNotification = () => {
  const queryStore = useNotificationQueryStore()
  const uiStore = useNotificationUIStore()

  // ===== QUERY CREATION FUNCTIONS =====

  const createAllNotificationsInfiniteQuery = () => {
    return queryStore.createAllNotificationsInfiniteQuery()
  }

  const createUnreadNotificationsInfiniteQuery = () => {
    return queryStore.createUnreadNotificationsInfiniteQuery()
  }

  // ===== MUTATIONS =====

  const createMarkAsReadMutation = () => {
    return queryStore.createMarkAsReadMutation
  }

  // ===== CONVENIENCE METHODS =====

  const markNotificationAsRead = async (notificationId?: string, refId?: string) => {
    const mutation = createMarkAsReadMutation()
    return mutation.mutateAsync({ notificationId, refId })
  }

  const clearNotifications = () => {
    queryStore.clearAll()
  }

  const invalidateAll = () => {
    queryStore.invalidateAll()
  }

  // ===== UI STATE HELPERS =====

  const setNotificationVisibility = (visibility: 'all' | 'unread') => {
    uiStore.setNotificationVisibility(visibility)
  }

  const setMarkAllRead = (value: boolean) => {
    uiStore.setMarkAllRead(value)
  }

  const setLoadMoreNotifications = (value: boolean) => {
    uiStore.setLoadMoreNotifications(value)
  }

  const setShowNotificationList = (value: boolean) => {
    uiStore.setShowNotificationList(value)
  }

  const reset = () => {
    uiStore.reset()
    queryStore.clearAll()
  }

  return {
    // Query creation functions
    createAllNotificationsInfiniteQuery,
    createUnreadNotificationsInfiniteQuery,

    // Mutations
    createMarkAsReadMutation,

    // Convenience methods
    markNotificationAsRead,
    clearNotifications,
    invalidateAll,

    // UI state
    notificationVisibility: uiStore.notificationVisibility,
    markAllRead: uiStore.markAllRead,
    loadMoreNotifications: uiStore.loadMoreNotifications,
    showNotificationList: uiStore.showNotificationList,

    // UI actions
    setNotificationVisibility,
    setMarkAllRead,
    setLoadMoreNotifications,
    setShowNotificationList,
    reset,

    // Query keys for manual invalidation
    queryKeys: queryStore.queryKeys,
  }
}
